import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { INGREDIENT } from "./ingredient";
import { MarmitonTaxonomyName } from "./taxonomyName";

var MARMITON_TAXONOMIES = _defineProperty({}, MarmitonTaxonomyName.Ingredient, INGREDIENT);

export * from "./taxonomyName";
export { MARMITON_TAXONOMIES };